/* eslint-disable no-useless-constructor */
import React from 'react';
import { connect } from 'react-redux';

class RoleView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { roles, auth, children } = this.props;
    if (roles.length > 0) {
      if (roles.some(role => auth.user.role.some(r => r === role))) {
        return children || <div />;
      }
    }

    return <div />;
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(RoleView);



// WEBPACK FOOTER //
// ./src/components/RoleView.js